import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogActions, MatDialogClose, MatDialogContent, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ScnackbarData, SnackbarStyles, ToastService } from '../../../../commons/toast.service';
import { NuevaTarea, AccionTarea } from '../../../../models/Tarea';
import { TareaService } from '../../../../services/tarea.service';
import { AvanceComponent } from '../avance/avance.component';
import { DateService, MY_DATE_FORMATS } from '../../../../shared/date.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { UtilService } from '../../../../services/util.service';

@Component({
    selector: 'app-reabrir',
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-EC' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    ],
    imports: [
        MatDialogModule, MatDialogActions, MatDialogClose, MatDialogContent,
        MatButtonModule, MatIconModule,
        FormsModule, ReactiveFormsModule, MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatDatepickerModule
    ],
    templateUrl: './reabrir.component.html',
    styleUrl: './reabrir.component.scss'
})
export class ReabrirComponent {
  readonly dialogRef = inject(MatDialogRef<AvanceComponent>);
  readonly data = inject<NuevaTarea>(MAT_DIALOG_DATA);

  nuevaTarea: NuevaTarea

  reabrirForm = new FormGroup({
    maxDate: new FormControl(new Date(new Date().setDate(new Date().getDate() + 1)), {
      validators: [Validators.required]
    }),
    comentario: new FormControl("", {
      validators: [Validators.required]
    })
  })

  fetchingReabrirTarea = false

  snackbarData: ScnackbarData = {}
  minDate = new Date(new Date().setDate(new Date().getDate() + 1))

  constructor(
    private tareaService: TareaService,
    private toast: ToastService,
    private utilService: UtilService,
    private dateService: DateService
  ) {
    this.nuevaTarea = structuredClone(this.data)
  }

  ngOnInit(): void {
    this.utilService.getFechaSugerida(new Date()).subscribe({
      next:(res:any)=>{
        this.reabrirForm.get("maxDate")?.setValue(res);
      }
    });
  }

  close() {
    this.fetchingReabrirTarea = true
    const formControls = this.reabrirForm.controls
    const accionTareas: AccionTarea[] = [
      {
        id: this.nuevaTarea.id,
        idParticipante: this.nuevaTarea.idAsignado,
        comentario: formControls.comentario.value!,
        avance: 0,
        fechaExpira: this.dateService.formatDateToCustomString(formControls.maxDate.value!)
      }
    ]
    this.tareaService.reabrirTarea(accionTareas).subscribe({
      next: (_) => {
        this.snackbarData.message = "Tarea reabierta"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"
        this.fetchingReabrirTarea = false
        this.toast.show(this.snackbarData)
        this.utilService.callTasks();
        this.dialogRef.close({ success: true })
      },
      error: (_) => {
        this.snackbarData.message = "Error reabriendo tarea"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.fetchingReabrirTarea = false
        this.toast.show(this.snackbarData)
        this.dialogRef.close({ success: false })
      }
    })
  }

}
